<template>
    <div>
        <div class="appHeader">
            <div class="left">
                <router-link :to="{name:'account'}" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">{{ title }}</div>
        </div>
        <div id="appCapsule">
            <div class="section full mt-1">
                <div class="wide-block pt-2 pb-2 pl-3 pr-3">
                    {{ content }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['title','content'],
    mounted() {
        if(this.title == undefined && this.content == undefined){
            this.$router.push({name:'404'})
        }
    },
}
</script>